module.exports = __webpack_public_path__ + "prod/1.42.2/img/about-bg.475d28b2.png";